import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/siteData";

const Services = () => {
  useSEO({
    title: "Ydelser | Konstruktion, nedrivning og renovering – AA+PLUS MILJØSANERING",
    description: "Konstruktionsarbejde, nedrivning, renovering, opførelse af bygninger, byggepladsservice og underentreprise for danske erhvervskunder.",
  });
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
    }
  }, [hash]);

  return (
    <div data-testid="services-page">
      <section className="bg-[#1F2937] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">Ydelser</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl">Bygge- og konstruktionsarbejde for virksomheder</h1>
          <p className="mt-5 text-lg text-gray-300 max-w-2xl leading-relaxed">
            Alle opgaver aftales individuelt ud fra omfang, placering, tidsplan, materialer og den nødvendige kapacitet.
          </p>
        </div>
      </section>

      {SERVICES.map((s, i) => (
        <section key={s.slug} id={s.slug} className={`py-16 lg:py-24 scroll-mt-24 ${i % 2 ? "bg-gray-50 border-y border-gray-200" : ""}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className={`grid lg:grid-cols-2 gap-12 items-center ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Reveal>
                <div className="overflow-hidden rounded-sm border border-gray-200">
                  <img src={s.image} alt={s.alt} className="w-full h-72 lg:h-96 object-cover" />
                </div>
              </Reveal>
              <Reveal delay={0.1}>
                <span className="inline-flex items-center justify-center w-12 h-12 bg-[#FF5A00]/10 rounded-sm mb-5">
                  <s.icon className="text-[#FF5A00]" size={24} />
                </span>
                <h2 className="text-3xl font-bold tracking-tight text-gray-900">{s.title}</h2>
                <p className="mt-4 text-lg text-gray-600 leading-relaxed">{s.long}</p>

                <h3 className="mt-8 font-bold text-gray-900 text-sm uppercase tracking-wider">Typiske arbejdsopgaver</h3>
                <ul className="mt-4 space-y-2">
                  {s.tasks.map((t) => (
                    <li key={t} className="flex items-start gap-3 text-gray-700">
                      <Check size={18} className="text-[#FF5A00] mt-0.5 shrink-0" /> {t}
                    </li>
                  ))}
                </ul>

                <h3 className="mt-8 font-bold text-gray-900 text-sm uppercase tracking-wider">Relevante kundetyper</h3>
                <div className="mt-3 flex flex-wrap gap-2">
                  {s.customers.map((c) => (
                    <span key={c} className="text-sm bg-white border border-gray-300 text-gray-700 px-3 py-1 rounded-sm">{c}</span>
                  ))}
                </div>

                <Link to="/kontakt" data-testid={`service-cta-${s.slug}`} className="mt-8 inline-flex items-center gap-2 bg-[#FF5A00] text-white font-semibold px-6 py-3 rounded-sm hover:bg-[#E04F00] transition-colors">
                  Indhent tilbud <ArrowRight size={18} />
                </Link>
              </Reveal>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
